/**
 * 获取文件名
 * @param url
 * @returns
 */
export function getFileName(url: string) {
  const urlObj = new URL(url);
  const filename = urlObj.pathname.split("/").pop();
  return decodeURIComponent(filename!);
}

/**
 * 获取文件名后缀
 * @param str
 * @returns
 */
function getExtname(str: string) {
  var slug = str.split(/\/|\\/).slice(-1)[0];
  var idx = slug.lastIndexOf(".");
  if (idx <= 0) return "";
  var ext = slug.slice(idx);
  return ext;
}

/**
 * 是否是图片
 * @param url
 * @returns
 */
export const isImage = (url: string) => {
  const ext = getExtname(url);

  if (ext === ".png" || ext === ".jpeg") return true;
  return false;
};

/**
 * 是否是视频
 * @param url
 * @returns
 */
export const isVideo = (url: string) => {
  const ext = getExtname(url);

  if (ext === ".mp4") return true;
  return false;
};

/**
 * 是否允许预览文件
 * @param url
 * @returns
 */
export const isPreviewAllowed = (url: string) => {
  const allowedFileExts = [
    ".jpg",
    ".jpeg",
    ".png",
    ".docx",
    ".doc",
    ".xslx",
    ".mp4",
    ".pptx",
    ".pdf",
  ];

  const ext = getExtname(url);
  if (allowedFileExts.includes(ext)) return true;

  return false;
};

export const convertFileItems = (url?: string) => {
  if (!url) return [];

  return url.split(",").map((item) => {
    return {
      url: item,
      name: getFileName(item),
    };
  });
};
